import { render, staticRenderFns } from "./SaleOrderDetail.vue?vue&type=template&id=bb1f2536"
import script from "./SaleOrderDetail.vue?vue&type=script&lang=js"
export * from "./SaleOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports